<spark-layout>

  <!-- slot / menu -->
  <layout-side-menu>

    <spark-shared-sidebar-sub-menu
      heading="Reports"
      [routePrefix]="['/reports']"
      [items]="items">
    </spark-shared-sidebar-sub-menu>

  </layout-side-menu>

  <!-- slot / content -->
  <layout-content>

    <router-outlet></router-outlet>

  </layout-content>

</spark-layout>
